import React from 'react';

import './FmMapRasterNotice.css';

export interface FmMapRasterNoticeProps {
  /** Plain-language notice that part of the basemap imagery is missing. */
  message: string;
  testId?: string;
}

/**
 * Map-canvas notice for a raster basemap gap: a glass status line pinned to
 * the bottom of the Leaflet container, above its panes and controls. It never
 * takes pointer input, so the map stays operable underneath it.
 */
export const FmMapRasterNotice: React.FC<FmMapRasterNoticeProps> = ({ message, testId }) => (
  <output className="fm-map-raster-notice" data-testid={testId}>
    {message}
  </output>
);
